/**
 * Add a new category
 *
 * @param vars
 * @returns {boolean}
 */
function add_document_type(vars) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/documents/types/add/',
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit((data) => {
                popup.close();
                $('body').doneLoading();

                squde_reload_for_flashes();

                if (vars && vars.callback) {
                    vars.callback(data);
                } else {
                    reload_location_if_needed(false);
                }
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * View the given category
 *
 * @param id
 * @param vars
 * @returns {boolean}
 */
function view_document_type(id) {
    const $ = jQuery.noConflict();


    $.squdeAjaxPopup({
        url: '/documents/types/view/'+id,
        onOpen: function(elm, popup) {
            elm.find('form').ajaxFormSubmit((data) => {
                popup.close();
                updateObject('documenttype', id);
                $('body').doneLoading();

                squde_reload_for_flashes();
            }, function(xhr, status, error) {
                $('body').doneLoading();
                squde_flash("Er ging iets mis bij het opslaan.","alert");
            }.bind([elm,popup]), function() {
                $('body').isLoading('dark');
            });
        }
    });
    return false;
}

/**
 * Delete the given type
 *
 * @param id
 * @param name
 * @returns {boolean}
 */
function delete_document_type(id, name) {
    const $ = jQuery.noConflict();
    name = decodeURI(name);
    custom_delete_with_confirmation("/documents/types/delete/" + id,id,"Weet u zeker dat u \""+name+"\" wilt verwijderen?",'documenttype');

    return false;
}